// MolecularWeightCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "Kalkulator Berat Molekul";
const DESCRIPTION =
  "Gunakan Kalkulator Berat Molekul untuk menghitung berat molekul senyawa kimia apa pun dengan mudah. Masukkan unsur-unsur kimia yang menyusun senyawa untuk menghitung berat molekul secara akurat.";
const KEYWORDS =
  "kalkulator berat molekul, hitung berat molekul, berat atom, tabel periodik, kimia, massa molar, kalkulator kimia";
const OG_URL =
  "https://do-calculate.com/calculator/id/molecular-weight-calculator/";
const ELEMENTS = {
  H: 1.008,
  He: 4.0026,
  Li: 6.94,
  Be: 9.0122,
  B: 10.81,
  C: 12.011,
  N: 14.007,
  O: 15.999,
  F: 18.998,
  Ne: 20.18,
  Na: 22.99,
  Mg: 24.305,
  Al: 26.982,
  Si: 28.085,
  P: 30.974,
  S: 32.06,
  Cl: 35.45,
  Ar: 39.948,
  K: 39.098,
  Ca: 40.078,
  Sc: 44.956,
  Ti: 47.867,
  V: 50.942,
  Cr: 51.996,
  Mn: 54.938,
  Fe: 55.845,
  Co: 58.933,
  Ni: 58.693,
  Cu: 63.546,
  Zn: 65.39,
  Ga: 69.723,
  Ge: 72.64,
  As: 74.922,
  Se: 78.96,
  Br: 79.904,
  Kr: 83.798,
  Rb: 85.468,
  Sr: 87.62,
  Y: 88.906,
  Zr: 91.224,
  Nb: 92.906,
  Mo: 95.94,
  Tc: 98.907,
  Ru: 101.07,
  Rh: 102.906,
  Pd: 106.42,
  Ag: 107.868,
  Cd: 112.414,
  In: 114.818,
  Sn: 118.71,
  Sb: 121.76,
  Te: 127.6,
  I: 126.905,
  Xe: 131.293,
  Cs: 132.906,
  Ba: 137.327,
  La: 138.906,
  Ce: 140.116,
  Pr: 140.908,
  Nd: 144.242,
  Pm: 144.913,
  Sm: 150.36,
  Eu: 151.964,
  Gd: 157.25,
  Tb: 158.925,
  Dy: 162.5,
  Ho: 164.93,
  Er: 167.259,
  Tm: 168.934,
  Yb: 173.04,
  Lu: 174.967,
  Hf: 178.49,
  Ta: 180.948,
  W: 183.84,
  Re: 186.207,
  Os: 190.23,
  Ir: 192.217,
  Pt: 195.078,
  Au: 196.967,
  Hg: 200.59,
  Tl: 204.383,
  Pb: 207.2,
  Bi: 208.98,
  Po: 208.98,
  At: 209.987,
  Rn: 222.176,
  Fr: 223.019,
  Ra: 226.025,
  Ac: 227.028,
  Th: 232.038,
  Pa: 231.036,
  U: 238.029,
  Np: 237.048,
  Pu: 244.064,
  Am: 243.061,
  Cm: 247.07,
  Bk: 247.07,
  Cf: 251.08,
  Es: 252.083,
  Fm: 257.095,
  Md: 258.099,
  No: 259.101,
  Lr: 262.11,
  Rf: 267.12,
  Db: 268.13,
  Sg: 271.14,
  Bh: 270.14,
  Hs: 277.15,
  Mt: 278.16,
  Ds: 281.17,
  Rg: 281.17,
  Cn: 285.18,
  Nh: 286.19,
  Fl: 289.2,
  Mc: 289.2,
  Lv: 293.21,
  Ts: 294.22,
  Og: 294.22,
};
function MolecularWeightCalculator() {
  const [selectedElement, setSelectedElement] = useState("");
  const [quantity, setQuantity] = useState();
  const [compound, setCompound] = useState([]);
  const [result, setResult] = useState(0);
  const [steps, setSteps] = useState([]);
  const [error, setError] = useState("");
  const handleAddElement = () => {
    if (selectedElement) {
      setCompound([...compound, { element: selectedElement, quantity }]);
      setSelectedElement("");
      setQuantity(1);
    }
  };
  const handleCalculate = () => {
    try {
      let totalWeight = 0;
      let calculationSteps = [];
      compound.forEach(({ element, quantity }) => {
        const elementWeight = ELEMENTS[element] * quantity;
        totalWeight += elementWeight;
        calculationSteps.push(
          `${quantity} × ${
            ELEMENTS[element]
          } (${element}) = ${elementWeight.toFixed(2)} g/mol`
        );
      });
      setResult(totalWeight);
      setSteps(calculationSteps);
      if (totalWeight === 0) {
        setError("Harap pilih elemen untuk melakukan perhitungan");
        return;
      }
      setError("");
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator ini menghitung berat molekul senyawa kimia apa pun menggunakan jumlah berat atom dari unsur-unsur penyusunnya.
                </p>
                <p>
                  <strong>
                    Berat Molekul = Jumlah berat atom unsur-unsur penyusun senyawa
                  </strong>
                </p>
                <ul>
                  <li>Pilih unsur kimia dan jumlah atom dalam senyawa.</li>
                  <li>Tambahkan unsur-unsur penyusun senyawa untuk menghitung total berat molekul.</li>
                </ul>
                <p>
                  Kalkulator ini dikembangkan untuk memudahkan proses penghitungan berat molekul senyawa kimia apa pun secara akurat dan mudah.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div >
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="element">
                        Pilih Unsur Kimia
                      </label>
                      <select
                        id="element"
                        value={selectedElement}
                        onChange={(e) => setSelectedElement(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="">Pilih Unsur</option>
                        {Object.keys(ELEMENTS).map((el) => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="quantity">
                        Jumlah Atom
                      </label>
                      <input
                        id="quantity"
                        type="number"
                        value={quantity}
                        onChange={(e) => setQuantity(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleAddElement}
                    >
                      Tambah Unsur
                    </button>
                    <br />
                    <ul>
                      {compound.map((item, index) => (
                        <li key={index}>
                          {item.quantity} × {item.element}
                        </li>
                      ))}
                    </ul>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Hitung
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Error: {error}
                    </p>
                  )}
                  {result > 0 &&  (
                    <div className="p-3 mb-2 bg-success">
                      <h4 className="text-white">Hasil:</h4>
                      <p className="text-white">{result.toFixed(2)} g/mol</p>
                      <div
                        className="p-3 mb-2 bg-info text-black"
                        style={{ width: "100%" }}
                      >
                        <h4>Langkah-langkah:</h4>
                        <ul>
                          {steps.map((step, index) => (
                            <li key={index}>{step}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Apa itu Berat Molekul?</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Konsep Berat Molekul</h2>
                  </u>
                  <p>
                    Berat molekul adalah jumlah berat atom dari semua atom yang menyusun senyawa kimia.
                  </p>
                  <ul>
                    <li>
                      <strong>
                        Berat Molekul = Jumlah berat atom unsur-unsur
                      </strong>
                    </li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    Contoh: Berat molekul air (H₂O) = (2×1) + (16) = 18 g/mol.
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Bagaimana Cara Menghitung Berat Molekul?
                    </h2>
                  </u>
                  <p>
                    Untuk menghitung berat molekul senyawa kimia apa pun, pilih unsur-unsur kimia dan jumlah atom setiap unsur.
                  </p>
                  <ul>
                    <li>
                      Gunakan tabel periodik untuk memilih berat atom yang benar.
                    </li>
                    <li>
                      Anda dapat menggunakan kalkulator kami untuk melakukan perhitungan dengan mudah dan akurat.
                    </li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    Contoh: Menghitung berat molekul karbon dioksida (CO₂).
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default MolecularWeightCalculator;